import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Role } from '../../features/users/models/role.enum';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const allowedRoles = route.data?.['roles'] as Role[] | undefined;
  const user = auth.user();
  const token = route.queryParamMap.get('token');

  /**
   * Reset password por token (SIN sesión)
   */
  if (!user && token && state.url.startsWith('/change-password')) {
    return true;
  }

  /**
   * No autenticado → login
   */
  if (!user) {
    return router.parseUrl('/login');
  }

  /**
   * Usuario eliminado o inactivo
   * Backend:
   * - NUNCA debe emitir token si active = false o deleted = true
   * - Esto es una segunda barrera (defensa en profundidad)
   */
  if (!user.active || user.deleted) {
    auth.logout();
    return router.parseUrl('/login');
  }

  /**
   * Forzar cambio de contraseña
   * Backend:
   * - Al crear usuario: mustChangePassword = true
   * - Al cambiar contraseña: mustChangePassword = false
   */
  if (user.mustChangePassword && state.url !== '/change-password') {
    return router.parseUrl('/change-password');
  }

  /**
   * Rutas sin roles → acceso permitido
   */
  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  /**
   * Validación por rol
   */
  if (allowedRoles.includes(user.role)) {
    return true;
  }

  /**
   * Rol no autorizado
   */
  return router.parseUrl('/dashboard');
};
